import { CarFront, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useVehicleSales } from "../data/assets-platform-data";

export function VehicleSalesPage() {
  const query = useVehicleSales();
  if (query.isLoading) return <Skeleton className="dashboard-skeleton" />;
  if (query.error) {
    return (
      <EmptyState title="Não foi possível carregar as vendas" description={query.error.message} />
    );
  }

  return (
    <Card
      title="Venda de veículos"
      description="Vendas à vista e parceladas, contratos, transferências e recebíveis."
      action={
        <Link to="/operacoes/nova?tipo=vehicle-sale">
          <Button>
            <Plus size={16} /> Nova venda
          </Button>
        </Link>
      }
    >
      <div className="funnel-strip">
        <div>
          <strong>150</strong>
          <span>Parcelados ativos</span>
        </div>
        <div>
          <strong>12</strong>
          <span>Transferências pendentes</span>
        </div>
        <div>
          <strong>8</strong>
          <span>Parcelas vencidas</span>
        </div>
        <div>
          <strong>R$ 1,08 mi</strong>
          <span>Saldo futuro demo</span>
        </div>
        <div>
          <strong>2</strong>
          <span>Em renegociação</span>
        </div>
      </div>

      <DataTable
        rows={query.data ?? []}
        getKey={(row) => row.id}
        columns={[
          {
            key: "number",
            header: "Contrato",
            render: (row) => (
              <span className="strong-link">
                <CarFront size={15} /> {row.number}
              </span>
            ),
          },
          { key: "customer", header: "Comprador", render: (row) => row.customer },
          { key: "vehicle", header: "Veículo", render: (row) => row.vehicle },
          {
            key: "mode",
            header: "Forma",
            render: (row) => (
              <Badge tone={row.mode === "CASH" ? "success" : "info"}>
                {row.mode === "CASH" ? "À VISTA" : "PARCELADA"}
              </Badge>
            ),
          },
          { key: "total", header: "Venda", render: (row) => row.total },
          {
            key: "terms",
            header: "Entrada / parcelas",
            render: (row) => `${row.downPayment} · ${row.installments}x`,
          },
          {
            key: "status",
            header: "Status",
            render: (row) => (
              <Badge tone={row.status === "ACTIVE" ? "success" : "neutral"}>{row.status}</Badge>
            ),
          },
          {
            key: "transfer",
            header: "Transferência",
            render: (row) => <Badge tone="warning">{row.transfer}</Badge>,
          },
        ]}
      />
    </Card>
  );
}
